import axios from 'axios'

const baseUrl = '/api/stations'

export class StationService {
    // Get tests
    static getStations(pageSize, requestPage, searchTerm) {
        return new Promise(async (resolve, reject) => {
            try {
                let results = await axios.get(baseUrl)
                resolve(results.data)
            }
            catch (err) {
                reject(err)
            }
        })
    }

    // Get test by Id
    static getStationByStationId(stationId) {
        return new Promise(async (resolve, reject) => {
            try {
                let result = await axios.get(`${baseUrl}/${stationId}`)
                resolve(result.data)
            }
            catch (err) {
                reject(err)
            }
        })
    }
}